export default __webpack_public_path__ + "static/media/ri_checkbox-circle-line.769eb4df.svg";